import { Fragment } from "react/jsx-runtime";
import { Badges, Image, LI, P, UL } from "../../../../../AbstractElements";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { changeChat, createNewChatAsync } from "../../../../../ReduxToolkit/Reducers/ChatSlice";
import { AllMemberType } from "../../../../../Types/ChatType";
import { dynamicImage } from "../../../../../Utils";
import SearchNotFoundClass from "../../../../CommonComponents/SearchNotFound/SearchNotFoundClass";

const ChatUserProfile = () => {
  const { members, selectedUser, currentUser, chats } = useAppSelector((state) => state.chat);
  var activeChat = 0;
  if (selectedUser != null) activeChat = selectedUser.id;
  const dispatch = useAppDispatch();
  const changeChatClick = (selectUser: number) => {
    const currentUserId = currentUser?.id;
    const currentChat = chats.find((x: { users: number[] }) => currentUser?.id !== undefined && x.users.includes(currentUser?.id) && x.users.includes(selectUser));
    if (currentChat) dispatch(changeChat(selectUser));
    else dispatch(createNewChatAsync({ currentUserId, selectUser, chats }));
  };
  return (
    <Fragment>
      {members && members.length > 0 ? (
        <UL className="chats-user simple-list flex-row custom-scrollbar">
          {members
            .filter((x: AllMemberType) => x.id !== currentUser?.id)
            .map((item: AllMemberType, id: number) => (
              <LI className={`common-space ${activeChat === item.id ? "active" : ""}`} key={id} onClick={() => changeChatClick(item.id)}>
                <div className="chat-time">
                  <div className="active-profile">
                    <Image className="img-fluid rounded-circle" src={dynamicImage(`${item.image}`)} alt="user" />
                    <div className={`status bg-${item.online}`} />
                  </div>
                  <div>
                    <span>{item.name}</span>
                    <P>{item.status}</P>
                  </div>
                </div>
                <div>
                  <P>{item.time} </P>
                  {item.badge && (<Badges color="success">{item.badge}</Badges>)}
                </div>
              </LI>
            ))}
        </UL>
      ) : (<SearchNotFoundClass word="Contact" />)}
    </Fragment>
  );
};
export default ChatUserProfile;
